import '../../css/content.css';
import React, {useContext, useLayoutEffect, useState} from 'react';
import { VideoContext } from '../../context/VideoContext';
import { VideoData } from "../../data/Videos";
import { VideoPlayerWithTranscript, VideoTitle } from "../VideoPlayer";
import VideoContainer from "../VideoContainer";
import gsap from 'gsap';

const Content3 = () => {

  const partialRef = React.useRef(null);
  const videoPlayerRef = React.useRef(null);
  const [mounted, setMounted] = useState(false);
  const [videoData, setVideoData] = useState({});
  const { currentDeepDiveIndex } = useContext(VideoContext);

  useLayoutEffect(() => {
    if (currentDeepDiveIndex !== 3) return;
    setVideoData(VideoData.find((video) => video.id === "843697848"));
    setMounted(true);
    gsap.to(partialRef.current, { opacity: 1, duration: 0.8, delay:.3, ease: "power3.out" })
    return () => {
      setMounted(false);
    };
  }, [currentDeepDiveIndex]);

  return (
    <>
      {/* 1 */}
      <div ref={partialRef} id="partial-0" className="partial-container partial-container-2 flex mobile:!justify-center opacity-0">
      <div className="min-h-fit">
        {
          (mounted) && 
          <>
              <VideoTitle>{videoData.title}</VideoTitle>
              <VideoContainer>
                <VideoPlayerWithTranscript ref={videoPlayerRef} videoData={videoData} />
              </VideoContainer>
          </>
        }       
        </div>
      </div>
    </>
  )
};

export default Content3;